import { ref, computed } from "vue"
import { useStore } from "vuex"
import { useCommonDicts } from "./useCommonDicts"

// LLM:METADATA
// :hierarchy: [Domain:Initialization | Role:Composable | Pattern:Orchestrator]
// :relates-to: uses: "useCommonDicts", uses: "adminClient", uses: "store", required-by: "App.vue"
// :rationale: "Manages the initial data loading sequence (dicts, modules) required for the app to function."
// :contract: post: "Application static data is loaded into Vuex"
// LLM:END

export function useAppInit() {
  const store = useStore()
  const { loadDicts } = useCommonDicts()

  const isDataLoaded = ref(false)
  // params is kept for future use when API URL needs to be dynamic
  const params = computed(() => store.getters.getParams())
  const modules = computed(() => store.getters.getModules())

  /**
   * Initialize application data
   * Should be called after authentication is confirmed
   */
  const initAppData = async () => {
    if (isDataLoaded.value) return

    try {
      // 1. Load Dictionaries
      await loadDicts()

      // 2. Load Modules List (if empty)
      if (!modules?.value?.length) {
        try {
          await store.dispatch("ensureModulesList")
        } catch (error) {
          console.warn("[AppInit] Failed to load modules", error)
        }
      }
    } catch (error) {
      console.error("[AppInit] Initialization failed", error)
    } finally {
      // Always set isDataLoaded to true, even if initialization fails
      // This ensures the app can mount and show error states if needed
      isDataLoaded.value = true
    }
  }

  return {
    isDataLoaded,
    initAppData,
    params, // Exported for potential future use
  }
}
